import { createSlice } from '@reduxjs/toolkit'

export const selectedProfileSimulateSlice = createSlice({
    name: 'selectedProfileSimulate',
    initialState: {
        result: undefined,
    },
    reducers: {
        setSelectedProfileSimulate: (state, action) => {
            state.result = action.payload;
        },
        clearSelectedProfileSimulate: (state) => {
            state.result = undefined;
        },
    },
})

export const { setSelectedProfileSimulate, clearSelectedProfileSimulate } = selectedProfileSimulateSlice.actions;

export const getSelectedProfileSimulate = (state) => state.selectedProfileSimulate.result;

export default selectedProfileSimulateSlice.reducer